module.exports = __webpack_public_path__ + "img/batyam-header.485c0b1a.svg";